import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectToVehicles } from './-redirect';

// Splat covers this legacy prefix's descendants (`/new`, `/:vehicleId`), redirecting each to its counterpart under `/vehicles`.
export const Route = createFileRoute('/_app/fleet-management/digital-vehicle-files/$')({
  beforeLoad: ({ location }) => {
    throw redirect(redirectToVehicles(location.href));
  },
});
